import * as React from "react";
import styled from "styled-components";
import { Row, Col, Alert } from "components/bootstrap";
import OrientationSelect from "report/report-creation/OrientationSelect";
import FormikSwitch from "report/report-creation/FormikSwitch";
import Separator from "report/report-creation/Separator";
import useReportForm from "report/report-creation/useReportForm";
import { FormikInput, InputDescription } from "components/common";
import ReportLogoEdit from "report/report-creation/content/ReportLogoEdit";
import PageSizeSelect from "./PageSizeSelect";
const ChildOptions = styled.div`
  padding-top: 5px;
`;
const PageNumbers = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 3px;

  label {
    font-size: 16px;
  }
`;
const Style = ({ editAllowed }) => {
  const {
    values: { layout, hideWidgetDescription }
  } = useReportForm();
  const format = layout == null ? void 0 : layout.format;
  const isPDF = !format || format === "PDF";
  return /* @__PURE__ */ React.createElement(React.Fragment, null, !isPDF && /* @__PURE__ */ React.createElement(Alert, { bsStyle: "warning" }, 'These options do not take effect because they can only be applied for "PDF format".'), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 6 }, /* @__PURE__ */ React.createElement(PageSizeSelect, { disabled: !isPDF || !editAllowed })), /* @__PURE__ */ React.createElement(Col, { md: 6 }, /* @__PURE__ */ React.createElement(OrientationSelect, { disabled: !isPDF || !editAllowed })), /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(Separator, null), /* @__PURE__ */ React.createElement(FormikSwitch, { name: "layout.printHeader", label: "Header", disabled: !isPDF || !editAllowed }), (layout == null ? void 0 : layout.printHeader) && /* @__PURE__ */ React.createElement(ChildOptions, null, /* @__PURE__ */ React.createElement(InputDescription, { help: "The header will be displayed for every page in the actual PDF file." }), /* @__PURE__ */ React.createElement(ReportLogoEdit, null), /* @__PURE__ */ React.createElement(
    FormikInput,
    {
      label: "Header text",
      name: "layout.header",
      id: "layout.header",
      type: "textarea",
      help: "The header will not be shown in the cover page or the table of contents once printed as a PDF file. Please ignore this on the preview.",
      maxLength: 330
    }
  )), /* @__PURE__ */ React.createElement(Separator, null), /* @__PURE__ */ React.createElement(FormikSwitch, { name: "layout.printFooter", label: "Footer", disabled: !isPDF || !editAllowed }), (layout == null ? void 0 : layout.printFooter) && /* @__PURE__ */ React.createElement(ChildOptions, null, /* @__PURE__ */ React.createElement(InputDescription, { help: "The footer will be displayed for every page in the actual PDF file." }), /* @__PURE__ */ React.createElement(PageNumbers, null, /* @__PURE__ */ React.createElement(FormikSwitch, { label: "Page numbers", name: "layout.printPageNumbers" })), /* @__PURE__ */ React.createElement(
    FormikInput,
    {
      label: "Footer text",
      name: "layout.footer",
      id: "layout.footer",
      type: "textarea",
      maxLength: 330
    }
  )), /* @__PURE__ */ React.createElement(Separator, null), /* @__PURE__ */ React.createElement(FormikSwitch, { name: "layout.printToc", label: "Table of Contents", disabled: !isPDF || !editAllowed }), /* @__PURE__ */ React.createElement(Separator, null), /* @__PURE__ */ React.createElement(
    FormikSwitch,
    {
      name: "hideWidgetDescription",
      label: "Hide widget description",
      disabled: !isPDF || !editAllowed
    }
  ), /* @__PURE__ */ React.createElement(Separator, null), /* @__PURE__ */ React.createElement(
    FormikSwitch,
    {
      name: "hideWidgetQuery",
      label: "Hide query in widget description",
      disabled: !isPDF || hideWidgetDescription || !editAllowed
    }
  ))));
};
export default Style;
